"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import PublicNavbar from "components/ui/v2/navbar/PublicNavbar";

export type PublicPageLayoutV2Width = "sm" | "md" | "lg" | "xl" | "7xl";

const WIDTH: Record<PublicPageLayoutV2Width, string> = {
  sm: "max-w-lg",
  md: "max-w-2xl",
  lg: "max-w-4xl",
  xl: "max-w-5xl",
  "7xl": "max-w-7xl",
};

export interface PublicPageLayoutV2Props {
  children: React.ReactNode;
  width?: PublicPageLayoutV2Width;
  showNavbar?: boolean;
  className?: string;
  centered?: boolean;
}

/** Public routes: portal, errors, job detail — same tokens as authenticated app. */
export function PublicPageLayoutV2({
  children,
  width = "md",
  showNavbar = true,
  className,
  centered = true,
}: PublicPageLayoutV2Props) {
  return (
    <div className="min-h-screen bg-white text-slate-900 dark:bg-zinc-950 dark:text-zinc-50">
      {showNavbar ? <PublicNavbar /> : null}
      <main
        className={cn(
          "mx-auto w-full px-4 py-8 sm:px-6",
          WIDTH[width],
          centered && "flex min-h-[calc(100vh-4rem)] flex-col justify-center",
          className,
        )}
      >
        {children}
      </main>
    </div>
  );
}
